import { LoadingContext } from "../Context";
import { ProfileLayout } from "../Container/Layout";
import React, { useContext, useEffect, useState } from "react";
import { TransactionGetOrders } from "../Services/Transactions";
import { ordersType } from "../Structures";
import { formatDate, formatPrice } from "../Utils";
import { Button, Empty } from "../Components/Base";
import { Modal } from "../Components/Modal";

const PaymentHistory = () => {
  const { loading, setLoading } = useContext(LoadingContext);

  // ================================================================================================================

  const [selectedOrder, setSelectedOrder] = useState<ordersType | null>(null);
  const [orders, setOrders] = useState<ordersType[]>([]);

  // ================================================================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetOrders()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setOrders(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ================================================================================================================

  return (
    <ProfileLayout>
      <Empty
        data={orders}
        isLoading={loading}
        description="درحال حاضر پرداختی انجام نداده اید"
      >
        <div className="col-12">
          <div className="row">
            {orders.map((order) => (
              <div key={order.id} className="col-sm-6 col-md-4">
                <div className="card border p-3 h-100">
                  <div className="position-relative">
                    <div
                      className="position-relative z-index-9"
                      style={{ height: 200 }}
                    >
                      <img
                        className="card-img w-100 h-100 object-fit-cover"
                        src={order.screen_shot}
                        alt="screenshot image"
                      />
                    </div>
                  </div>

                  <div className="card-body d-flex justify-content-between align-items-center text-center pb-0 p-3 px-0">
                    <span
                      className={`px-3 py-1 rounded-2 bg-${
                        order.is_verified ? "success" : "danger"
                      }-subtle text-${
                        order.is_verified ? "success" : "danger"
                      }`}
                    >
                      {order.is_verified ? "تایید شده" : "تایید نشده"}
                    </span>
                    <h6 className="mb-0">{formatDate(order.payment_time)}</h6>
                  </div>
                  <hr />
                  {order.items.map((item) => (
                    <div
                      key={item.id}
                      className="d-flex mb-2 justify-content-between align-items-center w-100"
                    >
                      <p
                        className="m-0 fs-6 fw-bold truncate flex-grow-1"
                        style={{ width: 1 }}
                      >
                        {item.product.title}
                      </p>
                      <p className="m-0">
                        {formatPrice(item.product.price)} تومان
                      </p>
                    </div>
                  ))}

                  <hr />
                  <Button
                    btnClass="w-100 btn-primary-soft m-0"
                    text="مشاهده فیش واریزی"
                    onClick={() => setSelectedOrder(order)}
                  />
                </div>
              </div>
            ))}
          </div>
          {selectedOrder ? (
            <Modal close={() => setSelectedOrder(null)}>
              <div className="z-index-99 bg-transparent overflow-hidden mw-520 mb-4">
                <div style={{width: 'fit-content'}} className="card-fold mw-100 mx-auto overflow-hidden position-relative rounded-3">
                  <img
                    className="card-img object-fit-contain"
                    src={selectedOrder.screen_shot}
                    alt="Card image"
                    style={{maxHeight: "80vh"}}
                  />
                </div>
              </div>
            </Modal>
          ) : null}
        </div>
      </Empty>
    </ProfileLayout>
  );
};
export default PaymentHistory;
